export const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', path: '/admin',           icon: 'dashboard' },
  { id: 'bookings',  label: 'Bookings',  path: '/admin/bookings',  icon: 'bookings',  badge: 5 },
  { id: 'services',  label: 'Services',  path: '/admin/services',  icon: 'services'  },
  { id: 'products',  label: 'Products',  path: '/admin/products',  icon: 'products'  },
  { id: 'projects',  label: 'Projects',  path: '/admin/projects',  icon: 'projects'  },
  // { id: 'vehicles',  label: 'Vehicles',  path: '/admin/vehicles',  icon: 'vehicles'  },
  // { id: 'customers', label: 'Customers', path: '/admin/customers', icon: 'customers' },
  // { id: 'reports',   label: 'Reports',   path: '/admin/reports',   icon: 'reports'   },
]
